import React, { Fragment, ReactNode } from "react";

export const DescriptionListEntry = ({
    term,
    details,
    className,
    showTitle
}: {
    term: ReactNode;
    details: ReactNode;
    className?: string;
    showTitle?: boolean;
}) => (
    <Fragment>
        <div className={className}>
            <dt title={showTitle ? term?.toString() : ""}>{term}</dt>
            <dd>{details}</dd>
        </div>
    </Fragment>
);
